import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

import LoginModal from '@App/components/LoginModal/LoginModal';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

import NavItem from './NavItem/NavItem';

import './nav.css';

function Nav() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const accountMenuRef = useRef(null);
  const { checkedAuthentication, isLoggedIn, logOut, userDetails } = useAuth();

  const accountName = userDetails?.email || userDetails?.username || '';

  let accountNavigation = <div className="nav__account-placeholder" aria-hidden="true" />;

  if (checkedAuthentication) {
    accountNavigation = isLoggedIn
      ? (
          <div className="nav__account" ref={accountMenuRef}>
            <NavItem
              icon="/img/icons/account.svg"
              isCollapsed={isCollapsed}
              onClick={() => setShowAccountMenu(!showAccountMenu)}
            >
              <span className="nav__account__name" title={accountName}>{accountName}</span>
            </NavItem>
            {showAccountMenu && (
              <div className="nav__account__menu">
                <button type="button" onClick={logOut}>Afmelden</button>
              </div>
            )}
          </div>
        )
      : (
          <NavItem
            icon="/img/icons/account.svg"
            isCollapsed={isCollapsed}
            onClick={() => setShowLoginModal(true)}
          >
            Aanmelden
          </NavItem>
        );
  }

  useEffect(() => {
    if (!showAccountMenu) return undefined;

    function closeAccountMenu(event) {
      if (!accountMenuRef.current?.contains(event.target)) {
        setShowAccountMenu(false);
      }
    }

    document.addEventListener('pointerdown', closeAccountMenu);
    return () => document.removeEventListener('pointerdown', closeAccountMenu);
  }, [showAccountMenu]);

  return (
    <div className={`nav${isCollapsed ? ' nav--collapsed' : ''}`}>
      <div className="nav__top">
        <NavLink className="nav__top__title" to="/">
          <span className="nav__top__title__part">{isCollapsed ? 'P' : 'Potentieelkaart'}</span>
          <span className="nav__top__title__part">{isCollapsed ? 'a' : 'aquathermie'}</span>
          <span className="nav__top__title__part">{isCollapsed ? 'V' : 'Vlaanderen'}</span>
        </NavLink>
        <NavItem
          icon="/img/icons/bronnen.svg"
          isCollapsed={isCollapsed}
        >
          Bronnen
        </NavItem>
        <NavItem
          icon="/img/icons/afnemers.svg"
          isCollapsed={isCollapsed}
        >
          Afnemers
        </NavItem>
        <div className="nav__top__divider" />
        <NavItem
          icon="/img/icons/installaties.svg"
          iconSize="19px"
          isCollapsed={isCollapsed}
        >
          Installaties
        </NavItem>
        <NavItem
          icon="/img/icons/layers.svg"
          iconSize="16.5px"
          isCollapsed={isCollapsed}
        >
          Randvoorwaarden
        </NavItem>
      </div>
      <div className="nav__bottom">
        <NavItem
          icon="/img/icons/info.svg"
          isCollapsed={isCollapsed}
        >
          Info / FAQ
        </NavItem>
        {accountNavigation}
        <div className="nav__bottom__divider" />
        <NavItem
          icon={`/img/icons/${isCollapsed ? 'expand' : 'collapse'}-sidebar.svg`}
          onClick={() => setIsCollapsed(!isCollapsed)}
          isCollapsed={isCollapsed}
        >
          Menu inklappen
        </NavItem>
      </div>
      {showLoginModal && <LoginModal isOpen={showLoginModal} setIsOpen={setShowLoginModal} />}
    </div>
  );
}

export default Nav;
